import http from "../jslibs/axios/http";

// 用户列表
export const getUserList = (data) => http.get("/v1/cms/User", data);
// 用户详情
export const getUserDetail = (uuid) => http.get(`/v1/cms/User/${uuid}`);
// 禁用、解禁
export const banUser = (uuid) => http.get(`/v1/cms/UserOption/${uuid}`);
// 修改密码
export const updatePwd = (uuid, data) => http.put(`/v1/cms//user/reset_pwd/${uuid}`, data);

export const learnExport = (data) => http.down("/v1/cms/LearnExport", data);
